import React from 'react';
import styled from 'styled-components/macro';
import vw from 'rpf/un/vw';
import Modal from 'components/Modal';
import autobg from 'autobg.macro';
import { formatPhone } from 'utils';

const Wrap = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: ${vw(690)};
  height: ${vw(493)};
  background-color: #ffffff;
  border-radius: ${vw(20)};
`;

const Title = styled.div`
  margin: ${vw(84)} 0 ${vw(20)};
  font-size: ${vw(40)};
  color: #2c2d40;
  text-align: center;
`;

const Text = styled.div`
  text-align: center;
  color: #2c2d40;
  font-size: ${vw(36)};
  span {
    color: #4460b7;
  }
`;

const Tips = styled.div`
  margin: ${vw(26)} 0 ${vw(42)};
  padding: 0 ${vw(36)} 0 ${vw(67)};
  color: #6669a1;
  font-size: ${vw(26)};
  line-height: 1.4;
  > span {
    color: #d41717;
  }
`;

const OkBtn = styled.div`
  ${autobg('assets/img/home/btn_ok.png')}
`;

const IsJoinModal = ({ mobile, open, onClose }) => {
  return (
    <Modal open={open}>
      <Wrap>
        <Title>您已提交申请</Title>
        <Text>
          预约手机号码：<span>{formatPhone(mobile)}</span>
        </Text>
        <Tips>
          *温馨提示:如您已持有中行国际借记卡，可直接
          <span>参与消费返现活动</span>
          ；如您未开办国际借记卡，请至<span>中国银行营业网点办理</span>。
        </Tips>
        <OkBtn onClick={onClose} />
      </Wrap>
    </Modal>
  );
};

export default IsJoinModal;
